import defaultV2Client from '@/plugins/axios/defaultV2Client'

export default {
  requestVerifications({ phone, purpose }) {
    return defaultV2Client.post('verifications/request', { phone, purpose })
  },

  confirmVerifications(token, { code }) {
    return defaultV2Client.put(`verifications/request/${token}/confirm`, { code })
  },
}
